import type { ReactNode } from 'react';

// Trust pill — primary-soft on primary-line, uppercase, used for
// compliance proofs (Reg D 506(c), ERC-3643, Base L2, Stripe ID).
// See preview/pills.html (trust row).

export type TrustPillProps = { children: ReactNode };

export function TrustPill({ children }: TrustPillProps) {
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-pill text-[10px] font-bold uppercase tracking-wider border border-primary-line bg-primary-soft text-primary">
      {children}
    </span>
  );
}
